window.addEventListener("load", function () {
  window.cookieconsent.initialise({
    revokeBtn: "<div class='cc-revoke'></div>",
    type: "opt-in",
    position: "bottom-right",
    palette: {
      popup: {
        background: "#fff",
      },
      button: {
        background: "#57B274",
      },
    },
    content: {
      message:
        "Wir verwenden Cookies, um unsere Webseite für Sie möglichst benutzerfreundlich zu gestalten.",
      link: "Weitere Informationen",
      allow: "Cookies erlauben",
      deny: "Ablehnen",
      href: "/datenschutz/",
    },
    onInitialise: function (status) {
      if (status == cookieconsent.status.allow) addGoogleTrackingCode();
    },
    onStatusChange: function (status) {
      if (this.hasConsented()) addGoogleTrackingCode();
    },
  });
});


function addGoogleTrackingCode(trackingCode)
{
  /*var s = document.createElement("script");
  s.type = "text/javascript";
  s.src = "https://www.googletagmanager.com/gtag/js?id=AW-16493730779";
  s.setAttribute('async','');
  $("head").append(s);
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', 'AW-16493730779');*/

  var s2 = document.createElement("script");
  s2.type = "text/javascript";
  s2.text = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','GTM-PB3NTXX7');";
  $("head").append(s2);
  
}